import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = () => {
    const phoneNumber = '+919876543210'; // Placeholder
    const message = encodeURIComponent('Hi! I\'m interested in Aitrixy\'s SEO services.');
    
    return (
        <a
            href={`https://wa.me/${phoneNumber}?text=${message}`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-float"
            aria-label="Contact us on WhatsApp"
            data-testid="whatsapp-button"
        >
            <MessageCircle className="w-7 h-7 text-white" fill="white" />
        </a>
    );
};
